/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchContractingPartyToContractV1Dto = {
  /**
   * The current version of the contracting-party-to-contract
   */
  version: number;
  /**
   * The unique identifier of the contract linked to the relation.
   */
  contractId: string | null;
  /**
   * The unique identifier of the customer linked to the relation.
   */
  customerId?: string | null;
  /**
   * The unique identifier of the partner linked to the relation.
   */
  partnerId?: string | null;
  /**
   * The unique identifier of the caretaker linked to the relation.
   */
  caretakerId?: string | null;
  /**
   * The role of the contracting-party in the contract.
   */
  role: PatchContractingPartyToContractV1Dto.role;
  /**
   * The date from which the relation is valid.
   */
  validFrom?: string | null;
  /**
   * The date until which the relation is valid.
   */
  validTo?: string | null;
};
export namespace PatchContractingPartyToContractV1Dto {
  /**
   * The role of the contracting-party in the contract.
   */
  export enum role {
    PROPERTY_OWNER = 'Property Owner',
    PROPERTY_LANDLORD = 'Property Landlord',
    PROPERTY_TENANT = 'Property Tenant',
    PROPERTY_MANAGER = 'Property Manager',
    CENTER_MANAGEMENT = 'Center Management',
    ADVERTISING_ASSOCIATION = 'Advertising Association',
    UTILITY_MANAGER = 'Utility Manager',
    CREDITOR_PAYEE_ = 'Creditor (Payee)',
  }
}
